import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "location-input-section" }
const _hoisted_2 = {
  key: 0,
  class: "error-message"
}
const _hoisted_3 = { id: "splash-screen-acknowledgements" }
const _hoisted_4 = { id: "splash-screen-logos" }

import {computed, ref } from 'vue';
import { MapBoxFeature, MapBoxFeatureCollection, geocodingInfoForSearch } from "@cosmicds/vue-toolkit/src/mapbox";

export interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cssVars?: any;
  title: string;
  color?: string,
  highlightColor?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SplashScreen',
  props: /*@__PURE__*/_mergeModels({
    cssVars: { default: () => ({}) },
    title: {},
    color: {},
    highlightColor: {}
  }, {
    "modelValue": { default: true },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['close', 'location-selected'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const cssVars = computed(() => {
  return {
    ...props.cssVars,
    ...{'--accent-color': props.color == null ? props.cssVars['--accent-color'] : props.color},
  };
});

const emits = __emit;

const showSplashScreen = _useModel(__props, "modelValue");
const searchErrorMessage = ref<string | null>(null);

const geocodingOptions = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  access_token: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN ?? "", 
};

function searchProvider(text: string): Promise<MapBoxFeatureCollection> {
  return geocodingInfoForSearch(text, geocodingOptions);
}

function handleLocationSet(feature: MapBoxFeature) {
  emits('location-selected', feature);
  searchErrorMessage.value = null;
}

function closeSplashScreen() {
  showSplashScreen.value = false;
  emits('close');
}



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_location_search = _resolveComponent("location-search")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_focus_trap = _resolveComponent("focus-trap")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_v_overlay, {
    "model-value": showSplashScreen.value,
    absolute: "",
    opacity: "0.6",
    style: _normalizeStyle(cssVars.value),
    id: "splash-overlay"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_focus_trap, null, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            id: "splash-screen",
            style: _normalizeStyle(cssVars.value)
          }, [
            _createVNode(_component_font_awesome_icon, {
              id: "close-splash-button",
              onClick: closeSplashScreen,
              onKeyup: _withKeys(closeSplashScreen, ["enter"]),
              icon: "xmark",
              tabindex: "0"
            }),
            _cache[4] || (_cache[4] = _createElementVNode("div", { id: "splash-title" }, [
              _createElementVNode("p", null, "The Sun's Seasonal Journey")
            ], -1)),
            _cache[5] || (_cache[5] = _createElementVNode("div", { id: "invitation" }, " See how the Sun's path changes on the solstices and equinoxes from any location on Earth! ", -1)),
            _createElementVNode("div", _hoisted_1, [
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "location-prompt" }, "Enter a location:", -1)),
              _createVNode(_component_location_search, {
                class: _normalizeClass(['splash-location-search']),
                small: "",
                "button-size": "large",
                "accent-color": cssVars.value['--accent-color'],
                "search-provider": searchProvider,
                onSetLocation: handleLocationSet,
                onError: _cache[0] || (_cache[0] = ($event: any) => (searchErrorMessage.value = $event)),
                placeholder: "Enter city, state, or address"
              }, null, 8, ["accent-color"]),
              (searchErrorMessage.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(searchErrorMessage.value), 1))
                : _createCommentVNode("", true)
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "medium" }, " or ", -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_v_btn, {
                class: "splash-get-started",
                onClick: closeSplashScreen,
                onKeyup: _withKeys(closeSplashScreen, ["enter"]),
                color: cssVars.value['--accent-color'],
                density: _ctx.$vuetify.display.xs ? 'compact' : 'default',
                size: _ctx.$vuetify.display.width < 500 || _ctx.$vuetify.display.height < 550 ? 'medium' : 'x-large',
                variant: "elevated",
                rounded: "lg"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Use Cambridge, MA ", -1)
                ]))]),
                _: 1
              }, 8, ["color", "density", "size"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("span", null, [
                _createTextVNode(" Brought to you by "),
                _createElementVNode("a", {
                  href: "https://www.cosmicds.cfa.harvard.edu/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "Cosmic Data Stories"),
                _createTextVNode(" and "),
                _createElementVNode("a", {
                  href: "https://www.worldwidetelescope.org/home/",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "WorldWide Telescope"),
                _createTextVNode(". ")
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_credit_logos, { "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa'] })
              ])
            ])
          ], 4)), [
            [_directive_click_outside, closeSplashScreen]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "style"]))
}
}

})